import { ProgressBar } from '@/components/ui'
import { useAccount, useSummary, useUsage } from '@/modules/account'
import { fromNow } from '@/utils'

const Label = ({ children }: { children: React.ReactNode }) => {
  return <span className="text-cp-grey-700 text-xs">{children}</span>
}

export const LegacyUsage = () => {
  const account = useAccount()
  const summary = useSummary()
  const { counter, progress, minProgress, hasLimitedPages } = useUsage()
  if (account?.planKind !== 'legacy_subscription') return

  return (
    <>
      <p className="text-xs font-semibold">Usage</p>
      <div className="flex flex-col gap-1">
        <Label>Pages · {counter}</Label>
        <ProgressBar
          progress={progress || 0}
          theme={progress === minProgress ? 'error' : 'success'}
          bordered
        />
        {hasLimitedPages && (
          <Label>{fromNow(summary?.pagesRenewCycle)} remaining in cycle</Label>
        )}
      </div>
    </>
  )
}
